import { animationOpacityIn } from 'style'

import Avatar from 'components/atomic/atoms/avatar'
import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import { TwitterIcon } from 'components/atomic/atoms/icons/logos/twitter'
import Text from 'components/atomic/atoms/text'

import { twitterReviews } from 'data/community/twitter-reviews'

const SharedTwitterWall = () => {
  return (
    <Box
      css={{
        display: 'flex',
        px: '$4',
        py: '$2',
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitoverflowScrolling: 'touch',
        cursor: 'grab',
        gap: '$8',
        '@md': {
          display: 'grid',
          gridCols: 3,
          mx: 'auto',
          p: 'auto',
          overflow: 'auto',
          cursor: 'auto',
        },
      }}
    >
      {twitterReviews.map(({ name, twitter, imageSrc, text, link }, index) => {
        const htmlString = text.replace(
          /([@|#][^,.\s]+)/gi, // e.g. match @username or #hashtag
          match => `<span>${match}</span>`,
        )

        return (
          <Box
            key={twitter}
            css={{
              spaceY: 6,
              p: '$5',
              minWidth: 280,
              maxWidth: 360,
              borderRadius: '$md',
              bgc: '$bgCard',
              border: '1px solid $borderCard',
              animation: `${animationOpacityIn} forwards`,
              opacity: 0,
              animationDelay: `${0.1 * index}s`,
            }}
          >
            <Box flex items="center" justify="between">
              <Box flex items="center" css={{ spaceX: 2 }}>
                <Avatar src={imageSrc} size="lg" />
                <Box flex="column">
                  <Text color="text1" size="sm">
                    {name}
                  </Text>
                  <Text color="text3" size="xs">
                    @{twitter}
                  </Text>
                </Box>
              </Box>
              <Text
                as="a"
                href={link}
                target="_blank"
                rel="noopener"
                aria-label={`Twit from ${name}`}
              >
                <IconStyled as={TwitterIcon} color="text1" size="2xl" />
              </Text>
            </Box>
            <Text
              as="p"
              color="text2"
              weight="medium"
              css={{
                whiteSpace: 'break-spaces',
                span: { color: '$secondary' },
              }}
              dangerouslySetInnerHTML={{ __html: htmlString }}
            />
          </Box>
        )
      })}
    </Box>
  )
}

export default SharedTwitterWall
